import { Input, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
//import { Directive, Input, OnInit, ViewContainerRef, TemplateRef, OnChanges } from '@angular/core';

@Directive({
	selector: '[timeline-thumb]'
})
export class TimelineThumbDirective  {

	@Input('timeline-thumb') sectionContent:any;
	elemExist = false;
	thumbWrap;
	constructor(private elRef: ElementRef, private renderer: Renderer2) {
	}

	ngOnInit() {
		
	}
	/*@HostListener('click') 
	performTask() {
		const li = this.renderer.createElement('li');
		const text = this.renderer.createText('Click here to add li');
		this.renderer.appendChild(li, text);
		this.renderer.appendChild(this.elRef.nativeElement, li);
	}*/


	@HostListener('click', ['$event.target']) onClick(targetElement) {
		let navBt = document.querySelector('.secondary-nav-button');
		if(!this.elemExist){
			this.createElem();
		}
		else{
			if ($(targetElement).parents('.timeline-thumbs').length) {
				this.renderer.addClass(this.thumbWrap, 'is-fullscreen');
				this.renderer.addClass(navBt, 'is-hidden');
			}
			else{
				this.removeElem();
			}
		}
	}

	@HostListener('document:click', ['$event.target'])
	performTask(targetElement) {
		const clickedInside = this.elRef.nativeElement.contains(targetElement);
		if (!clickedInside && this.elemExist) {
			this.removeElem();
		}
	}

	createElem(){
		this.renderer.addClass(this.elRef.nativeElement, 'is-active');
		this.thumbWrap = this.renderer.createElement('div');
		//thumbWrap.className = "timeline-thumbs is-loading";
		this.renderer.addClass(this.thumbWrap, 'timeline-thumbs');
		this.renderer.addClass(this.thumbWrap, 'is-loading');
		let thumb;
		let ratioThumb;

		if(this.sectionContent.type != 'video'){
			thumb = this.renderer.createElement('img');
			this.renderer.setAttribute(thumb, 'src', this.sectionContent.image);

			this.getElemsize(thumb, 'img');
			this.createBoxContent(this.thumbWrap);
		}
		else{
			thumb = this.renderer.createElement('video');
			this.renderer.setAttribute(thumb, 'src', this.sectionContent.video);	
			this.renderer.setAttribute(thumb, 'type', 'video/mp4');	
			this.renderer.setAttribute(thumb, 'playsinline', 'true');	
			this.renderer.setAttribute(thumb, 'autoplay', 'true');
			this.renderer.setAttribute(thumb, 'loop', 'true');
			this.getElemsize(thumb, 'video');
		}



		this.createCloseBt(this.thumbWrap);
	}


	createCloseBt(elem){
		elem.innerHTML += '<span class="resize-thumb"></span>'+
		'<span id="close-thumb" class="close-button close-thumb is-open white">'+
		'<div class="close-button__text-wrap">'+
		'<div class="close-button__text-wrap__text">'+
		'<span class="close-button__regular">All Events</span>'+
		'<span class="close-button__open">Close</span>'+
		'</div>'+
		'</div>'+
		'<div class="close-button__icon">'+
		'<span class="close-button__icon__line"></span>'+
		'</div>'
		'</span>';

		let closeBt = elem.querySelector('.close-thumb');
		closeBt.addEventListener("click", (e) => {
			let navBt = document.querySelector('.secondary-nav-button');
			setTimeout(() => {
				this.renderer.removeClass(navBt, 'is-hidden');
				this.removeElem();
			}, 100)
		})
	}

	createBoxContent(elem){
		let title = "";
		let text = "";
		if(this.sectionContent.title){	
			title = '<h2 class="heading-2 date white">'+ this.sectionContent.title +'</h2>';
		}
		if(this.sectionContent.text){
			text = '<p class="paragraph white">'+ this.sectionContent.text +'</p>'
		}
		elem.innerHTML += '<span class="timeline-thumb-content">'+title+''+text+'</span>';
	}

	removeElem(){
		this.renderer.removeClass(this.elRef.nativeElement, 'is-active');
		//this.thumbWrap = this.elRef.nativeElement.querySelector('.timeline-thumbs');
		this.renderer.addClass(this.thumbWrap, 'anim-out');
		setTimeout(() => {
			this.elemExist = false;	
			this.renderer.removeChild(this.elRef.nativeElement, this.thumbWrap);
		}, 500)
	}


	renderElem(thumb, ratio){
		//this.renderer.setStyle(this.thumbWrap, 'height', 400/ratio+'px');
		this.elemExist = true;

		this.renderer.removeClass(this.thumbWrap, 'is-loading');
		this.renderer.appendChild(this.thumbWrap, thumb);
	}

	getElemsize(thumb, type){
		this.renderer.appendChild(this.elRef.nativeElement, this.thumbWrap);
		if(type == 'img'){
			var getImageSizeBeforeLoad = setInterval(() => {
				//this intervall allow to have image size before loaded (allow to check thumb.width etc...)
				//if (thumb.naturalWidth) {
					clearInterval(getImageSizeBeforeLoad);
					let ratio = thumb.width/thumb.height;
					this.renderElem(thumb, ratio);
				//}
			}, 10);
		}
		else{
			var getImageSizeBeforeLoad = setInterval(() => {
				//if (thumb.readyState === 4) {
					clearInterval(getImageSizeBeforeLoad);
					let ratio =  thumb.videoWidth/thumb.videoHeight;
					this.renderElem(thumb, ratio);
				//}
			}, 10);
		}
	}





}

